import {
  BrandedConfig,
  ENV_BRAND_NWB,
  ENV_BRAND_RBS,
  ENV_BRAND_UBN,
} from "services/envService";

export const PRIVACY_COOKIES_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]: "https://www.natwest.com/global/cookie-privacy.html",
  [ENV_BRAND_RBS]:
    "https://www.rbs.co.uk/global/cookie-privacy.html?channel=business",
  [ENV_BRAND_UBN]: "https://www.ulsterbank.co.uk/globals/cookie-privacy.html",
};

export const WEBSITE_TC_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]: "https://www.natwest.com/website-terms-and-FSCS.html",
  [ENV_BRAND_RBS]: "https://www.rbs.co.uk/website-terms-and-FSCS.html",
  [ENV_BRAND_UBN]:
    "https://www.ulsterbank.co.uk/globals/website-terms-and-conditions.html",
};

export const SECURITY_CENTRE_LINKS: BrandedConfig = {
  [ENV_BRAND_NWB]: "https://www.natwest.com/fraud-and-security.html",
  [ENV_BRAND_RBS]: "https://www.rbs.co.uk/business/security.html",
  [ENV_BRAND_UBN]: "https://www.ulsterbank.co.uk/business/security.html",
};
